import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Opportunity } from '@app/shared/interfaces/lib/opportunity.interface';
import { config } from '@app/core/app-config';

@Injectable({
  providedIn: 'root',
})
export class OpportunitiesService {
  constructor(private http: HttpClient) {}

  getOpportunities(propertyId: number): Observable<{ data: Opportunity[] }> {
    return this.http.get<{ data: Opportunity[] }>(`${config.API_URL}/properties/${propertyId}/opportunities`);
  }

  applyOpportunity(propertyId: number, opportunityId: number): Observable<any> {
    return this.http.post(`${config.API_URL}/properties/${propertyId}/opportunities/${opportunityId}`, {});
  }
}
